import React from "react";
import { Input } from "semantic-ui-react";
import { WidgetProps } from '@rjsf/core';
import { useSchemaTranslation } from "../../../useSchemaTranslation";

interface IBaseInput extends WidgetProps {
  type?: string
  rawErrors: any
}

const BaseInput = (props: IBaseInput) => {
  const {
    id,
    disabled,
    value,
    onChange,
    onBlur,
    onFocus,
    options,
    autofocus,
    label,
    schema,
    readonly,
    placeholder,
    rawErrors,
    formContext,
    ...inputProps
  } = props
  const { t } = useSchemaTranslation();
  const { semanticProps = {} } = options

  const type = (typeof options.inputType === 'string' && options.inputType) || inputProps.type || "text";

  const _onChange = ({ target: { value }, }: React.ChangeEvent<HTMLInputElement>) => {
    return onChange(value === '' ? options.emptyValue : value)
  };

  const _onBlur = ({ target: { value } }: React.FocusEvent<HTMLInputElement>) => {
    return onBlur(id, value);
  }

  const _onFocus = ({ target: { value } }: React.FocusEvent<HTMLInputElement>) => {
    return onFocus(id, value);
  }

  if (readonly) {
    return <div> {value} </div>
  }

  return (
    <Input
      {...inputProps}
      //  label={label || schema.title}
      label={null}
      // @ts-ignore
      // error={inputProps.rawErrors && inputProps.rawErrors.length ? inputProps.rawErrors[0] : undefined}
      //  label={null}
      type={type}
      focus={autofocus}
      readOnly={readonly}
      placeholder={t(placeholder)}

      value={value}
      onChange={_onChange}
      onBlur={_onBlur}
      onFocus={_onFocus}
      {...semanticProps}
    />
  );
}

BaseInput.defaultProps = {
  type: "text",
  required: false,
  disabled: false,
  readOnly: false,
  autoFocus: false,
};

export default BaseInput;
